import { useMemo } from 'react';

import { selectAddons } from '@webapp/account/src/resources/survey/selectors';

import { useDeepSelector } from '@webapp/common/hooks/use-deep-selector';
import type { InfoDesignModel } from '@webapp/common/resources/entities/info';

export const useSurveyParamsAdapter = (): {
    params: Partial<any>; // TODO ISurveyInfoParamsModel
    design: InfoDesignModel;
} => {
    const addons = useDeepSelector(selectAddons);

    return useMemo(
        () => ({
            params: {
                alert: addons.alert,
                main: addons.main,
                other: addons.params,
                tests: addons.tests,
                share: addons.share,
            },
            design: {
                brand: addons.brand,
                buttons: addons.buttons,
                css: addons.css,
                fonts: addons.fonts,
                view: addons.view,
            },
        }),
        [addons],
    );
};
